import React, { Component } from 'react';
import { Chart } from 'primereact/chart';
import { dominioDemandaCirurgica } from '../../config/database';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { coresGraficos } from '../../util';

export class PieChartDemo extends Component {
    state = {}

    componentDidMount() {
    }

    render() {
        return (
          <>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader>
                    <strong>Quantidade de pedidos por Equipe no mês anterior</strong>
                    <Chart type="pie" data={this.state.pedidosPorEquipeMesAnterior} options={this.state.opcoesGraficoPizza} />
                  </CardHeader>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader>
                    <strong>Quantidade de pedidos por Procedimento no mês anterior</strong>
                    <Chart type="pie" data={this.state.pedidosPorProcedimentoMesAnterior} options={this.state.opcoesGraficoPizza} />
                  </CardHeader>
                </Card>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader>
                    <strong>Quantidade de pedidos por Status</strong>
                    <Chart type="bar" data={this.state.pedidosPorStatus} options={this.state.opcoesGraficoBarra} />
                  </CardHeader>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader>
                    <strong>Equipes que mais requisitaram</strong>
                    <Chart type="bar" data={this.state.pedidosPorEquipe} options={this.state.opcoesGraficoBarra} />
                  </CardHeader>
                </Card>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader>
                    <strong>Quantidade de pedidos nos últimos 7 dias por Equipe</strong>
                    <Chart type="line" data={this.state.pedidosPorDiaEquipe7Dias} options={this.state.opcoesGraficoLinha} />
                  </CardHeader>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card chart>
                  <CardHeader>
                    <strong>Quantidade de pedidos nos últimos 7 dias por Carater de Atendimento</strong>
                    <Chart type="line" data={this.state.pedidosPorDiaCarater7Dias} options={this.state.opcoesGraficoLinha} />
                  </CardHeader>
                </Card>
              </GridItem>
            </GridContainer>
          </>
        )
    }
}

export default PieChartDemo;